export default __webpack_public_path__ + "static/media/Reserve24Hrs.2b0f66b5.svg";